import React, { useEffect } from "react";
import PropTypes from "prop-types";
import createKeyCrawler from "./create-crawler";
const HotKey = _ref => {
  let {
    ignore = [],
    sequence,
    keyCompareFn = (x, y) => x === y,
    onMatch
  } = _ref;
  useHotKey(sequence, onMatch, {
    ignore,
    keyCompareFn
  });

  // we return a fragment so that react-docgen will recognize this as a component
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
HotKey.propTypes = {
  /** Order of keys pressed to watch for. To see what keys are available check out: [MDN docs on keys](https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values) */
  sequence: PropTypes.array.isRequired,
  /** Callback to execute when sequence of keys is pressed */
  onMatch: PropTypes.func.isRequired,
  /** Configure comparison logic of pressed keys */
  keyCompareFn: PropTypes.func,
  /** Keys to ignore */
  ignore: PropTypes.array
};
export default HotKey;
export const useHotKey = function (sequence, onMatch) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    keyCompareFn = (x, y) => x === y,
    ignore = []
  } = options;
  useEffect(() => {
    let keyCrawler = null;
    const setCrawler = () => {
      keyCrawler = createKeyCrawler([].concat(sequence), keyCompareFn);
    };
    const listen = e => {
      const {
        key
      } = e;
      const keyIgnore = [].concat(ignore);
      if (!~keyIgnore.indexOf(key) && keyCrawler(key)) {
        onMatch();
      }
    };
    setCrawler();
    window.addEventListener("keydown", listen);
    return () => {
      window.removeEventListener("keydown", listen);
    };
  }, [ignore, keyCompareFn, onMatch, sequence]);
};